import { FormattedMessage } from '@alltrails/shared/react-intl';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useLanguageCode from 'hooks/useLanguageCode';
import CustomProvider from 'components/CustomProvider';
import MarketingModal from './MarketingModal';
import * as styles from './styles/styles.module.scss';

function Picture() {
  const languageCode = useLanguageCode();
  // I think this is better than writing a bunch of import statements
  /* eslint-disable global-require, import/no-dynamic-require */
  const jpg = require(`./appinstall-${languageCode}.jpg`).default;
  const avif = require(`./appinstall-${languageCode}.avif`).default;
  const avif2x = require(`./appinstall-${languageCode}-2x.avif`).default;
  const avif3x = require(`./appinstall-${languageCode}-3x.avif`).default;
  /* eslint-enable global-require, import/no-dynamic-require */

  return (
    <picture>
      <source srcSet={avif} type="image/avif" />
      <source srcSet={`${avif2x} 2x`} type="image/avif" />
      <source srcSet={`${avif3x} 3x`} type="image/avif" />
      <img className={styles.img} src={jpg} />
    </picture>
  );
}

function AppInstallModal() {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <CustomProvider>
      <MarketingModal
        color="white"
        headerText={<FormattedMessage defaultMessage="Take your AllTrails experience on the go" />}
        instructionsText={
          languageRegionCode === LanguageRegionCode.English ? (
            <FormattedMessage defaultMessage="Try the AllTrails app for your iOS or Android phone. Enter your US mobile number to text yourself a link." />
          ) : (
            <FormattedMessage defaultMessage="Get more from AllTrails when you download the app on your iOS or Android phone." />
          )
        }
        picture={<Picture />}
      />
    </CustomProvider>
  );
}

export default AppInstallModal;
